import React, { useState, useLayoutEffect, useEffect } from 'react';
import { View, Text, TextInput, Button, StyleSheet, FlatList, TouchableOpacity, Alert, ScrollView, ActivityIndicator, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { addDoc, collection, doc, getDoc } from 'firebase/firestore'; 
import { db, auth } from '../firebaseConfig';
import { Modal } from 'react-native';
import { MaterialCommunityIcons, MaterialIcons, Ionicons } from '@expo/vector-icons'; // Substituindo por @expo/vector-icons




const CreateRouteScreen = () => {
  const [orders, setOrders] = useState([]);
  const [description, setDescription] = useState('');
  const [deliveryLocation, setDeliveryLocation] = useState('');
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [orderValue, setOrderValue] = useState('');
  const [locationType, setLocationType] = useState('');
  const [extraValue, setExtraValue] = useState(''); // Adicionado estado para "Extra"
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setModalVisible] = useState(false);
  const [routeValue, setRouteValue] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [cardType, setCardType] = useState('');
  const [changeValue, setChangeValue] = useState('');  
  const [companyData, setCompanyData] = useState({
    companyName: '',
    companyPhone: '',
    companyAddress: '',
    setorValue: '0.00',
    bairroValue: '0.00',
  });

  const navigation = useNavigation();

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: false,
    });
  }, [navigation]);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const user = auth.currentUser;
        if (!user) {
          console.log('Erro: Usuário não autenticado.');
          Alert.alert('Erro', 'Usuário não autenticado.');
          setLoading(false);
          return;
        }

        const companyDoc = await getDoc(doc(db, 'usuarios', user.uid));
        if (companyDoc.exists()) {
          const data = companyDoc.data();
          setCompanyData({
            companyName: data.companyName || 'Nome da Empresa não disponível',
            companyPhone: data.phone || 'Telefone não disponível',
            companyAddress: `${data.street || 'Endereço não disponível'}, ${data.number || 'Nº não disponível'}, ${data.cep || 'CEP não disponível'}`,
            setorValue: data.setorValue || '0.00',
            bairroValue: data.bairroValue || '0.00',
          });
        } else {
          Alert.alert('Erro', 'Dados da empresa não encontrados.');
        }
      } catch (error) {
        console.log('Erro ao buscar dados da empresa:', error);
        Alert.alert('Erro', 'Erro ao carregar informações da empresa.');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);


  const requestNotificationPermission = () => {
    if (Platform.OS === 'web' && 'Notification' in window) {
      if (Notification.permission === 'default') {
        Notification.requestPermission().then((permission) => {
          if (permission !== 'granted') {
            console.log('Permissão para notificações negada.');
          }
        });
      }
    }
  };

  useEffect(() => {
    requestNotificationPermission();
  }, []);

  const showNotification = (title, options) => {
    if (Platform.OS === 'web' && 'Notification' in window) {
      if (Notification.permission === 'granted') {
        new Notification(title, options);
      } else if (Notification.permission === 'default') {
        Notification.requestPermission().then((permission) => {
          if (permission === 'granted') {
            new Notification(title, options);
          } else {
            console.log('Permissão para notificações negada.');
          }
        });
      } else {
        console.log('Notificações não são permitidas no navegador.');
      }
    } else {
      console.log(`Notificação: ${title} - ${options.body}`);
    }
  };
  
  const handleValueChange = (setter) => (value) => {
    const formattedValue = value.replace(/\./g, ',');
    const regex = /^(\d+([,]\d{0,2})?)$/;
  
    if (regex.test(formattedValue) || formattedValue === '') {
      setter(formattedValue);
    }
  };
  

  const handleAddOrder = () => {
    if (orders.length >= 3) {
      Alert.alert('Atenção', 'Você já atingiu o limite máximo de 3 pedidos para esta rota.');
      return;
    }
  
    if (!description || !deliveryLocation || !clientName || !clientPhone || !orderValue || !locationType || !paymentMethod) {
      Alert.alert('Erro', 'Preencha todos os campos antes de adicionar o pedido à rota.');
      return;
    }
  
    let locationValue = '0.00';
    if (locationType === 'Setor') {
      locationValue = companyData.setorValue;
    } else if (locationType === 'Bairro') {
      locationValue = companyData.bairroValue;
    } else if (locationType === 'Extra') {
      locationValue = extraValue || '0.00';
    }
  
    const newOrder = {
      description,
      deliveryLocation,
      clientName,
      clientPhone,
      orderValue: parseFloat(orderValue.replace(',', '.')).toFixed(2),
      locationType,
      locationValue,
      paymentMethod,
      cardType: paymentMethod === 'cartao' ? cardType : '',
      changeValue: paymentMethod === 'dinheiro' ? parseFloat(changeValue.replace(',', '.')).toFixed(2) : '',
      verificationCode: Math.floor(1000 + Math.random() * 9000),
      companyName: companyData.companyName,
      companyPhone: companyData.companyPhone,
      companyAddress: companyData.companyAddress,
    };
  
    setOrders((prevOrders) => [...prevOrders, newOrder]);
    showNotification('Pedido Adicionado', {
      body: `Novo pedido adicionado: ${description}`,
    });
  
    // Resetar os campos de entrada
    setDescription('');
    setDeliveryLocation('');
    setClientName('');
    setClientPhone('');
    setOrderValue('');
    setLocationType('');
    setExtraValue('');
    setPaymentMethod('');
    setCardType('');
    setChangeValue('');
  };
  

  const handleSaveRoute = () => {
    if (orders.length === 0) {
      Alert.alert('Erro', 'Adicione pelo menos um pedido à rota.');
      return;
    }
  
    setModalVisible(true); // Abre o modal para o usuário digitar o valor da rota
  };
  
  const confirmSaveRoute = async () => {
    if (!routeValue || isNaN(routeValue.replace(',', '.'))) {
      Alert.alert('Erro', 'Por favor, insira um valor válido para a rota.');
      return;
    }
  
    try {
      const user = auth.currentUser;
      const newRoute = {
        companyId: user.uid,
        companyName: companyData.companyName,
        companyPhone: companyData.companyPhone,
        companyAddress: companyData.companyAddress,
        totalValue: parseFloat(routeValue.replace(',', '.')), // Converte vírgula para ponto antes de salvar
        createdAt: new Date(),
        status: 'pending',
        orders,
      };
  
      await addDoc(collection(db, 'routes'), newRoute);
      Alert.alert('Sucesso', 'Rota criada com sucesso!');
      showNotification('Rota Criada', {
        body: `Rota no valor de R$ ${routeValue} foi criada!`,
      });
      setOrders([]);
      setRouteValue('');
      setModalVisible(false); // Fecha o modal
      navigation.navigate('PendingOrdersScreen');
    } catch (error) {
      console.error('Erro ao salvar a rota:', error);
      Alert.alert('Erro', 'Erro ao salvar a rota.');
    }
  };
  

  const handleEditOrder = (index) => {
    const orderToEdit = orders[index];
    setDescription(orderToEdit.description);
    setDeliveryLocation(orderToEdit.deliveryLocation);
    setClientName(orderToEdit.clientName);
    setClientPhone(orderToEdit.clientPhone);
    setOrderValue(orderToEdit.orderValue);
    setLocationType(orderToEdit.locationType);
    setExtraValue(orderToEdit.locationType === 'Extra' ? orderToEdit.locationValue : '');
    setOrders((prevOrders) => prevOrders.filter((_, i) => i !== index));
  };

  const handleDeleteOrder = (index) => {
    if (Platform.OS === 'web') {
      // Confirmação para a web usando window.confirm
      const confirmDelete = window.confirm("Tem certeza que deseja remover este pedido?");
      if (confirmDelete) {
        setOrders((prevOrders) => prevOrders.filter((_, i) => i !== index));
        showNotification('Pedido Removido', {
          body: `Pedido removido da rota.`,
        });
      }
    } else {
      // Confirmação para dispositivos móveis
      Alert.alert(
        "Remover",
        "Tem certeza que deseja remover este pedido?",
        [
          { text: "Cancelar", style: "cancel" },
          {
            text: "Remover",
            onPress: () => {
              setOrders((prevOrders) => prevOrders.filter((_, i) => i !== index));
              showNotification('Pedido Removido', {
                body: `Pedido removido da rota.`,
              });
            },
          },
        ],
        { cancelable: false }
      );
    }
  };
  
  const renderContent = () => {
    if (view === 'createRoute') {
      return (
        <ScrollView style={styles.container}>
          <Text style={styles.title}>Criar Rota</Text>
          {/* Campos para criar rotas */}
        </ScrollView>
      );
    }

    if (view === 'pending') {
      return (
        <View style={styles.container}>
          <Text style={styles.title}>Pedidos Pendentes</Text>
          {/* Conteúdo de pedidos pendentes */}
        </View>
      );
    }

    if (view === 'accepted') {
      return (
        <View style={styles.container}>
          <Text style={styles.title}>Pedidos Aceitos</Text>
          {/* Conteúdo de pedidos aceitos */}
        </View>
      );
    }

    if (view === 'completed') {
      return (
        <View style={styles.container}>
          <Text style={styles.title}>Histórico</Text>
          {/* Conteúdo do histórico */}
        </View>
      );
    }

    if (view === 'profile') {
      return (
        <View style={styles.container}>
          <Text style={styles.title}>Perfil da Empresa</Text>
          {/* Conteúdo do perfil */}
        </View>
      );
    }

    return null; // Caso nenhuma view seja correspondente
  };

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#000" />
        <Text>Carregando dados da empresa...</Text>
      </View>
    );
  }

  return (
    <View style={{ flex: 1 }}>

  <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
    <MaterialIcons name="arrow-back" size={28} color="#FFF" />
  </TouchableOpacity>

  <ScrollView contentContainerStyle={styles.scrollContainer}>
    <View style={styles.container}>
    <View>
  <Text style={styles.title}>Criar Rota</Text>
  <Text style={styles.description}>
    Adicione até 3 pedidos ao mesmo destino.
  </Text>
</View>



      {/* Campos de entrada para adicionar pedido */}
      <View style={styles.inputContainer}>
        <MaterialIcons name="description" size={24} style={styles.icon} />
        <TextInput
          placeholder="Descrição do Pedido"
          placeholderTextColor="#FFF"
          value={description}
          onChangeText={setDescription}
          style={styles.input}
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="location-on" size={24} style={styles.icon} />
        <TextInput
          placeholder="Local de Entrega"
          placeholderTextColor="#FFF"
          value={deliveryLocation}
          onChangeText={setDeliveryLocation}
          style={styles.input}
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="person" size={24} style={styles.icon} />
        <TextInput
          placeholder="Nome do Cliente"
          placeholderTextColor="#FFF"
          value={clientName}
          onChangeText={setClientName}
          style={styles.input}
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="phone" size={24} style={styles.icon} />
        <TextInput
          placeholder="Telefone do Cliente"
          placeholderTextColor="#FFF"
          value={clientPhone}
          onChangeText={(text) => setClientPhone(text.replace(/[^0-9]/g, ''))}
          style={styles.input}
          keyboardType="numeric"
        />
      </View>

      <View style={styles.inputContainer}>
        <MaterialIcons name="attach-money" size={24} style={styles.icon} />
        <TextInput
          placeholder="Valor do Pedido"
          placeholderTextColor="#FFF"
          value={orderValue}
          onChangeText={(text) => setOrderValue(text.replace(/[^0-9,]/g, ''))}
          style={styles.input}
          keyboardType="numeric"
        />
      </View>

      {/* Botões de escolha do tipo de local */}
      {/* Botões de escolha do tipo de local */}
      <View style={styles.buttonGroup}>
  <TouchableOpacity
    style={[styles.choiceButton, locationType === 'Setor' && styles.selectedButton]}
    onPress={() => {
      setLocationType('Setor');
      setExtraValue(companyData.setorValue || '0.00'); // Define o valor fixo para "Setor"
    }}
  >
    <Text style={[styles.choiceButtonText, locationType === 'Setor' && styles.selectedButtonText]}>Setor</Text>
  </TouchableOpacity>
  <TouchableOpacity
    style={[styles.choiceButton, locationType === 'Bairro' && styles.selectedButton]}
    onPress={() => {
      setLocationType('Bairro');
      setExtraValue(companyData.bairroValue || '0.00'); // Define o valor fixo para "Bairro"
    }}
  >
    <Text style={[styles.choiceButtonText, locationType === 'Bairro' && styles.selectedButtonText]}>Bairro</Text>
  </TouchableOpacity>
  <TouchableOpacity
    style={[styles.choiceButton, locationType === 'Extra' && styles.selectedButton]}
    onPress={() => {
      setLocationType('Extra');
      setExtraValue('10,00'); // Valor fixo para "Extra"
    }}
  >
    <Text style={[styles.choiceButtonText, locationType === 'Extra' && styles.selectedButtonText]}>Extra</Text>
  </TouchableOpacity>
</View>



      {/* Botões de escolha do método de pagamento */}
      <View style={styles.buttonGroup}>
        <TouchableOpacity
          style={[styles.choiceButton, paymentMethod === 'cartao' && styles.selectedButton]}
          onPress={() => setPaymentMethod('cartao')}
        >
          <Text style={[styles.choiceButtonText, paymentMethod === 'cartao' && styles.selectedButtonText]}>Cartão</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.choiceButton, paymentMethod === 'dinheiro' && styles.selectedButton]}
          onPress={() => setPaymentMethod('dinheiro')}
        >
          <Text style={[styles.choiceButtonText, paymentMethod === 'dinheiro' && styles.selectedButtonText]}>Dinheiro</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.choiceButton, paymentMethod === 'pix' && styles.selectedButton]}
          onPress={() => setPaymentMethod('pix')}
        >
          <Text style={[styles.choiceButtonText, paymentMethod === 'pix' && styles.selectedButtonText]}>Pix</Text>
        </TouchableOpacity>
      </View>

      {/* Tipos de cartão */}
      {paymentMethod === 'cartao' && (
        <View style={styles.buttonGroup}>
          <TouchableOpacity
            style={[styles.choiceButton, cardType === 'debito' && styles.selectedButton]}
            onPress={() => setCardType('debito')}
          >
            <Text style={[styles.choiceButtonText, cardType === 'debito' && styles.selectedButtonText]}>Débito</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[styles.choiceButton, cardType === 'credito' && styles.selectedButton]}
            onPress={() => setCardType('credito')}
          >
            <Text style={[styles.choiceButtonText, cardType === 'credito' && styles.selectedButtonText]}>Crédito</Text>
          </TouchableOpacity>
        </View>
      )}

      {/* Valor do troco */}
      {paymentMethod === 'dinheiro' && (
        <View style={styles.inputContainer}>
          <MaterialIcons name="attach-money" size={24} style={styles.icon} />
          <TextInput
            placeholder="Valor do Troco"
            placeholderTextColor="#FFF"
            value={changeValue}
            onChangeText={(text) => setChangeValue(text.replace(/[^0-9,]/g, ''))}
            keyboardType="numeric"
            style={styles.input}
          />
        </View>
      )}

      {/* Botão para adicionar pedido */}
      <TouchableOpacity style={styles.buttonStyle} onPress={handleAddOrder}>
        <Text style={styles.buttonTextStyle}>Adicionar Pedido à Rota</Text>
      </TouchableOpacity>

      {/* Lista de Pedidos Adicionados */}
      <FlatList
  data={orders}
  keyExtractor={(item, index) => index.toString()}
  renderItem={({ item, index }) => (
    <View style={styles.orderItem}>
      <Text style={styles.orderText}>Pedido {index + 1}</Text>
      <Text style={styles.orderText}><Text style={{ fontWeight: 'bold' }}>Descrição:</Text> {item.description}</Text>
      <Text style={styles.orderText}><Text style={{ fontWeight: 'bold' }}>Local de Entrega:</Text> {item.deliveryLocation}</Text>
      <Text style={styles.orderText}><Text style={{ fontWeight: 'bold' }}>Cliente:</Text> {item.clientName}</Text>
      <Text style={styles.orderText}><Text style={{ fontWeight: 'bold' }}>Telefone:</Text> {item.clientPhone}</Text>
      <Text style={styles.orderText}>
        <Text style={{ fontWeight: 'bold' }}>Valor do Pedido:</Text> R$ {item.orderValue.replace('.', ',')}
      </Text>
      
      <Text style={styles.orderText}>
        <Text style={{ fontWeight: 'bold' }}>Tipo de Localização:</Text> {item.locationType}
      </Text>

      <Text style={styles.orderText}>
        <Text style={{ fontWeight: 'bold' }}>Forma de Pagamento:</Text> {item.paymentMethod || 'Não informado'}
      </Text>

      {item.paymentMethod === 'cartao' && (
        <Text style={styles.orderText}>
          <Text style={{ fontWeight: 'bold' }}>Tipo de Cartão:</Text> {item.cardType || 'Não informado'}
        </Text>
      )}

      {item.paymentMethod === 'dinheiro' && item.changeValue && (
        <Text style={styles.orderText}>
          <Text style={{ fontWeight: 'bold' }}>Troco para:</Text> R$ {item.changeValue.replace('.', ',')}
        </Text>
      )}

      <View style={styles.buttonRow}>
        <TouchableOpacity style={styles.editButton} onPress={() => handleEditOrder(index)}>
          <Text style={styles.editButtonText}>Editar</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.cancelButton} onPress={() => handleDeleteOrder(index)}>
          <Text style={styles.cancelButtonText}>Remover</Text>
        </TouchableOpacity>
      </View>
    </View>
  )}
  style={styles.orderList}
/>


      {/* Modal para Confirmar Salvar a Rota */}
      <Modal
        visible={isModalVisible}
        transparent={true}
        animationType="slide"
        onRequestClose={() => setModalVisible(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContainer}>
            <Text style={styles.modalTitle}>Valor Pago ao Motoboy</Text>
            <TextInput
              style={styles.modalInput}
              placeholder="Digite o valor total em reais"
              placeholderTextColor="#999"
              keyboardType="numeric"
              value={routeValue}
              onChangeText={(text) => {
                const formattedText = text.replace('.', ',').replace(/[^0-9,]/g, '');
                setRouteValue(formattedText);
              }}
            />
            <View style={styles.modalButtonRow}>
              <TouchableOpacity style={styles.buttonStyle} onPress={() => setModalVisible(false)}>
                <Text style={styles.buttonTextStyle}>Cancelar</Text>
              </TouchableOpacity>
              <TouchableOpacity style={styles.buttonStyle} onPress={confirmSaveRoute}>
                <Text style={styles.buttonTextStyle}>Salvar</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Botões para Salvar ou Cancelar */}
      <View style={styles.buttonRow}>
        <TouchableOpacity style={styles.buttonStyle} onPress={handleSaveRoute}>
          <Text style={styles.buttonTextStyle}>Salvar Rota</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.buttonStyle} onPress={() => navigation.goBack()}>
          <Text style={styles.buttonTextStyle}>Cancelar</Text>
        </TouchableOpacity>
      </View>
    </View>
  </ScrollView>
</View>
  );   
};

const styles = StyleSheet.create({
  scrollContainer: {
    flexGrow: 1,
    backgroundColor: '#2c5364', // Fundo consistente
  },
  container: {
    flex: 1, // Ocupa toda a tela
    padding: 16,
    paddingTop: 120, // Ajuste feito para espaçamento superior
    backgroundColor: '#2c5364', // Cor de fundo
    marginTop: 0, // Remove qualquer margem no topo
  },
  backButton: {
    position: 'absolute',
    top: 60,
    left: 30,
    padding: 10,
    zIndex: 1,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 20,
    color: '#FFF', // Texto em branco
    textAlign: 'center',
  },
  description: {
    fontSize: 20,
    color: '#FFF', // Cor mais clara para diferenciar do título
    textAlign: 'center',
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    borderColor: '#FFF', // Bordas brancas
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: '#2c5364', // Fundo escuro
  },
  input: {
    flex: 1,
    height: 50,
    color: '#FFF', // Texto em branco
    fontSize: 16,
    paddingLeft: 10,
  },
  icon: {
    color: '#FFF', // Ícones em branco
    marginRight: 10, // Espaço entre o ícone e o texto
  },
  buttonGroup: {
    flexDirection: 'row',
    marginBottom: 16,
  },
  choiceButton: {
    flex: 1,
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 10,
    borderColor: '#FFF', // Bordas brancas
    borderWidth: 1,
    marginLeft: 5,
    alignItems: 'center',
    backgroundColor: '#203a43', // Fundo escuro
  },
  selectedButton: {
    backgroundColor: '#FFF', // Fundo branco para seleção
  },
  choiceButtonText: {
    color: '#FFF', // Texto branco para botões não selecionados
  },
  selectedButtonText: {
    color: '#203a43', // Texto escuro ao selecionar
  },
  orderItem: {
    padding: 16,
    backgroundColor: '#203a43', // Fundo escuro para contraste
    borderRadius: 10,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: '#DDD',
  },
  orderText: {
    fontSize: 16,
    color: '#FFF', // Texto branco
    marginBottom: 5,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  spacer: {
    width: 10,
  },
  cancelButton: {
    backgroundColor: '#FF0000',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 5,
  },
  cancelButtonText: {
    color: '#FFF',
    fontWeight: 'bold',
  },
  editButton: {
    backgroundColor: '#FFA500',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 5,
  },
  editButtonText: {
    color: '#FFF',
    fontWeight: 'bold',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#2c5364', // Fundo consistente
  },
  modalOverlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContainer: {
    width: '80%',
    padding: 20,
    backgroundColor: '#FFF',
    borderRadius: 10,
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    color: '#2c5364',
  },
  modalInput: {
    width: '100%',
    height: 40,
    borderColor: '#CCC',
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 20,
    paddingHorizontal: 10,
    fontSize: 16,
    color: '#000',
  },
  modalButtonRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 20,
  },
  buttonStyle: {
    backgroundColor: '#203a43', // Cor do menu
    paddingVertical: 10,
    paddingHorizontal: 15,
    borderRadius: 10,
    alignItems: 'center',
    marginHorizontal: 5, // Espaçamento entre os botões
  },
  buttonTextStyle: {
    color: '#FFF', // Texto branco para contraste
    fontWeight: 'bold',
    fontSize: 16,
  },
});

export default CreateRouteScreen;
